import app from 'flarum/forum/app';
import LinkButton from 'flarum/common/components/LinkButton';
import GroupsSearchItem from './GroupsSearchItem';

/**
 * The `GroupsSearchSource` finds and displays group search results in
 * the search dropdown.
 */
export default class GroupsSearchSource {
  constructor() {
    this.results = new Map();
    this.queryString = null;
  }

  async search(query) {
    query = query.toLowerCase();

    this.results.set(query, []);

    this.setQueryString(query);

    try {
      // 调用 groups 扩展的 API
      const response = await app.request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/social-groups/frontend',
        headers: {
          'Content-Type': 'application/json',
        },
        params: {
          search: this.queryString || query,
          limit: this.limit(),
        },
      });

      if (response && response.data) {
        this.results.set(query, response.data);
      } else {
        this.results.set(query, []);
      }

      m.redraw();
    } catch (error) {
      console.error('Error searching groups:', error);
      this.results.set(query, []);
      m.redraw();
    }
  }

  view(query) {
    query = query.toLowerCase();

    this.setQueryString(query);

    const results = (this.results.get(query) || []).map((group) => {
      return <GroupsSearchItem query={query} group={group} />;
    });

    return [
      <li className="Dropdown-header">
        {app.translator.trans('tf-custom-header.forum.search.groups_heading')}
      </li>,
      <li>
        <LinkButton icon="fa-light fa-search" href={app.route('groups')}>
          {app.translator.trans('tf-custom-header.forum.search.all_groups_button', { query })}
        </LinkButton>
      </li>,
      ...results,
    ];
  }

  limit() {
    return 3;
  }

  setQueryString(query) {
    this.queryString = query;
  }
}
